import { useEffect, useRef, useState } from 'react';

function AssemblyTypeAutocomplete({ id, labelText, value, onValueChange, options, disabled, errorMessage, placeholder }) {
    const [isOpen, setIsOpen] = useState(false);
    const [highlightedIndex, setHighlightedIndex] = useState(-1);
    const containerRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const suggestions = (options || []).filter((type) =>
        !value || type.toLowerCase().includes(value.toLowerCase())
    );

    const selectSuggestion = (suggestion) => {
        onValueChange(suggestion);
        setIsOpen(false);
        setHighlightedIndex(-1);
    };

    return (
        <div>
            <div ref={containerRef} className='relative'>
                <label htmlFor={id} className='block text-gray-700 font-medium'>
                    {labelText}
                    <input
                        id={id}
                        value={value}
                        disabled={disabled}
                        autoComplete='off'
                        placeholder={placeholder}
                        onChange={(e) => {
                            onValueChange(e.target.value);
                            setIsOpen(true);
                            setHighlightedIndex(-1);
                        }}
                        onFocus={() => setIsOpen(true)}
                        onKeyDown={(e) => {
                            if (!isOpen || suggestions.length === 0) return;
                            if (e.key === 'ArrowDown') {
                                e.preventDefault();
                                setHighlightedIndex((i) => (i + 1) % suggestions.length);
                            } else if (e.key === 'ArrowUp') {
                                e.preventDefault();
                                setHighlightedIndex((i) => (i - 1 + suggestions.length) % suggestions.length);
                            } else if (e.key === 'Enter' && highlightedIndex >= 0) {
                                e.preventDefault();
                                selectSuggestion(suggestions[highlightedIndex]);
                            } else if (e.key === 'Escape') {
                                setIsOpen(false);
                            }
                        }}
                        className='block appearance-none w-full h-10 md:h-12 rounded-md border border-gray-300 focus:outline-gray-400 py-2 px-3 md:px-4 text-gray-900 placeholder:text-gray-400 sm:text-sm disabled:bg-gray-100 disabled:cursor-not-allowed min-w-32'
                    />
                </label>
                {isOpen && suggestions.length > 0 && (
                    <div className='absolute top-full left-0 z-20 mt-1 w-full max-h-60 overflow-auto rounded-md border border-gray-300 bg-white shadow-md'>
                        {suggestions.map((suggestion, index) => (
                            <div
                                key={suggestion}
                                onMouseDown={(e) => { e.preventDefault(); selectSuggestion(suggestion); }}
                                className={`px-3 py-2 text-sm cursor-pointer hover:bg-slate-100 ${index === highlightedIndex ? 'bg-slate-100' : ''}`}
                            >
                                {suggestion}
                            </div>
                        ))}
                    </div>
                )}
            </div>
            <p className='text-red-600 text-sm min-h-5'>{errorMessage || ''}</p>
        </div>
    );
}

export default AssemblyTypeAutocomplete;
